import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'endpointsFilterDescription'
})
export class EndpointsFilterDescriptionPipe implements PipeTransform {
    constructor() {}
    transform(register) {
        if(register && register.activeCalls && register.activeCalls > 0){
            return 'Em Chamada';
        }else {
            if(register && register.plcmH323Identity){
                if(register.plcmH323Identity.h323RegistrationState == 'ACTIVE'){
                    return 'Ativo';
                } else if(register.plcmH323Identity.h323RegistrationState == 'INACTIVE'){
                    return 'Inativo';
                } else if(register.plcmH323Identity.h323RegistrationState == 'QUARANTINED'){
                    return 'Em Quarentena';
                } else {
                    return 'Desconhecido';
                }
            }else if(register && register.plcmSipIdentityV2){
                if(register.plcmSipIdentityV2.sipRegistrationState == 'ACTIVE'){
                    return 'Ativo';
                } else if(register.plcmSipIdentityV2.sipRegistrationState == 'INACTIVE'){
                    return 'Inativo';
                } else if(register.plcmSipIdentityV2.sipRegistrationState == 'QUARANTINED'){
                    return 'Em Quarentena';
                } else {
                    return 'Desconhecido';
                }
            }
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/restricted/pipe/pipeEndpointsFiltersDescription.ts